import { Button, ButtonProps, Tooltip } from 'antd';
import { FC } from 'react';

interface WindowButtonProps extends Omit<ButtonProps, 'color' | 'type'> {
  icon: React.ReactNode;
  title: string;
}

export const WindowButton: FC<WindowButtonProps> = (props) => {
  const { icon, title, onClick } = props;

  return (
    <Tooltip placement="bottomLeft" title={title}>
      <Button {...props} type="text" icon={icon} onClick={onClick} />
    </Tooltip>
  );
};
